export default __webpack_public_path__ + "static/media/Group.56d17aca.svg";